import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomValidators } from 'ng2-validation';
import { FormControlRemote } from '../../../../../shared/form/element/form-control-remote';

@Injectable()
export class CustomerUserForm {

  constructor(private formBuilder: FormBuilder) {
  }

  public buildForm(update: boolean = false): FormGroup {
    const controlsConfig: any = {
      customer: new FormControlRemote('id'),
      campaign: new FormControlRemote('id'),
      firstName: [ '', Validators.required ],
      lastName: [ '', Validators.required ],
      phone: [ '' ],
      role: [ '', Validators.required ],
      email: [ '', Validators.compose([ Validators.required, CustomValidators.email ]) ],
      password: [ '' ]
    };
    if (!update) {
      controlsConfig.password = [ '', Validators.compose([ Validators.required, Validators.minLength(8) ]) ];
    }
    return this.formBuilder.group(controlsConfig);
  }
}
